import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { cn } from '../../../utils/classnames';

const PlannerSelect = ({ options = [], value, onChange, name = 'planner', label = 'PLANEJADOR' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = options.find((o) => o.value === value);

  // fechar ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!ref.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (val) => {
    onChange?.({ target: { name, value: val } });
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative inline-flex items-center">
      {/* Trigger */}
      <div
        onClick={() => setOpen((prev) => !prev)}
        className={cn(
          'flex items-center gap-1 border border-bluePale rounded-full px-5 py-2 bg-white cursor-pointer',
          'hover:bg-blueLight transition-colors'
        )}
      >
        <span className="text-xs text-blueMedium font-semibold tracking-wide">{label}:</span>

        <span className="text-xs text-blueMedium font-normal mr-2">{(selected?.label || 'TODOS').toUpperCase()}</span>

        <ChevronDown
          size={15}
          strokeWidth={1.5}
          className={cn('text-blueSteel transition-transform', open && 'rotate-180')}
        />
      </div>

      {/* Dropdown */}
      {open && (
        <div
          className={cn(
            'absolute top-full mt-2 w-full min-w-[200px] z-50',
            'bg-white border border-bluePale rounded-xl shadow-lg overflow-hidden'
          )}
        >
          <div className="py-1 max-h-60 overflow-y-auto">
            {options.map((opt) => {
              const isSelected = opt.value === value;

              return (
                <div
                  key={opt.value}
                  onClick={() => handleSelect(opt.value)}
                  className={cn(
                    'flex items-center justify-between px-4 py-2 text-sm cursor-pointer',
                    'hover:bg-blueLight transition-colors',
                    isSelected && 'bg-blueLight font-semibold'
                  )}
                >
                  <span className="text-blueDarker">{opt.label}</span>

                  {isSelected && <Check size={14} className="text-tealBase" />}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default PlannerSelect;
